import type {FC} from 'react'
import {useState} from 'react'
import {Box, Dialog} from '@mui/material'

/** A chat image: a small thumbnail that opens full size on click. */
const ImageThumbnail: FC<{src: string; alt: string}> = ({src, alt}) => {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Box
        component="img"
        src={src}
        alt={alt}
        onClick={() => setOpen(true)}
        sx={{
          maxWidth: 180,
          maxHeight: 120,
          borderRadius: 1.5,
          border: 1,
          borderColor: 'divider',
          cursor: 'zoom-in',
          display: 'block',
        }}
      />
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg">
        <Box
          component="img"
          src={src}
          alt={alt}
          sx={{maxWidth: '90vw', maxHeight: '85vh', display: 'block'}}
        />
      </Dialog>
    </>
  )
}

export default ImageThumbnail
